import { render, staticRenderFns } from "./ProjectEditScene.vue?vue&type=template&id=6b72fba0&"
import script from "./ProjectEditScene.vue?vue&type=script&lang=js&"
export * from "./ProjectEditScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports